import { Tag } from '@amzn/awscat-portfolio-assessment-types';

export interface PortfolioViewModel {
    portfolioId: string;
    portfolioName: string;
    accountName: string;
    createdAt: string;
    updatedAt: string;
    updatedBy: string;
    isDemo: boolean;
    refId?: string;
    permittedActions?: string[];
    tags?: Tag[];
}

export enum PrepopulateTypes {
    EMPTY = 'empty',
    SAMPLE = 'sample',
};

export enum OrgTypes {
    AWS = 'AWS',
    other = 'other',
};

export enum AccountOptions {
    CREATE_NEW = 'Create new',
    USE_EXISTING = 'Use Existing',
};

export enum PortfolioAction {
    UPDATE = 'update',
    ALL = '*',
    VIEW = 'View',
};
